import type { Id } from "@convex/_generated/dataModel";
import { createFileRoute } from "@tanstack/react-router";
import { RulesTab } from "@/features/employee/rules-tab";

export const Route = createFileRoute("/_app/_main/team/$employeeId/rules")({
  component: () => <RulesTab employeeId={Route.useParams().employeeId as Id<"employees">} />,
});
